"use client";
import { normalizeProductSummaryApi } from "../normalizePCP/normalize.js";
import { isBD } from "../../../utils/businessType.lib.js";
import { selectByWarehouse } from "../../../utils/product.js";
import { ECO_FEE_CATEGORY } from "../../../components/Product/EcoFee/constants.js";
import { getInWareHouseChannelBadgeData, getReplacementItemNumber, getDiscountsData, getPriceData, getDeliveryChannelBadgeData } from "./lib.js";
const normalizeProductSummaryApiV2 = (responseData, productConfig, hasUserSignedId, cookieContext, keyword, isSponsored, isProductDetailsPage, locale) => {
  var _a, _b, _c, _d, _e;
  const normalizedDataV1 = normalizeProductSummaryApi(
    { ...responseData },
    productConfig,
    hasUserSignedId,
    cookieContext,
    keyword,
    isSponsored,
    isProductDetailsPage
  );
  const { enabledWarehousesListConfig, translationsConfig, featureToggleConfig } = productConfig || {};
  const { inventoryResponseData, productApiResponseData } = responseData || {};
  const item = productApiResponseData && "productData" in productApiResponseData && Array.isArray(productApiResponseData.productData) ? productApiResponseData.productData[0] : void 0;
  if (!normalizedDataV1 || !item) {
    return null;
  }
  const { childCatalogData, isPublished, groupedLinkFee } = item || {};
  const { warehouse, deliveryLocation, bdDeliveryLocation } = cookieContext || {};
  const { nearestWarehouse } = warehouse || {};
  const childCatalogDisplayPrice = selectByWarehouse(
    (_a = childCatalogData == null ? void 0 : childCatalogData[0]) == null ? void 0 : _a.displayPrice,
    nearestWarehouse
  );
  const location = isBD() ? (_b = bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.bdLocation) == null ? void 0 : _b.slice(-2) : deliveryLocation == null ? void 0 : deliveryLocation.state;
  const linkFeePrices = ((_c = childCatalogData == null ? void 0 : childCatalogData[0]) == null ? void 0 : _c.groupedLinkFee) || groupedLinkFee || [];
  const relevantLinkFeePrice = linkFeePrices[location ? location : ""];
  const ecoFee = relevantLinkFeePrice == null ? void 0 : relevantLinkFeePrice.find(
    (fee) => fee.feeCategory === ECO_FEE_CATEGORY
  );
  const bopiwWarehouseEnabled = Boolean(
    (_d = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesBOPIWList) == null ? void 0 : _d.some(
      (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
    )
  );
  const wioWarehouseEnabled = Boolean(
    (_e = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesWIOList) == null ? void 0 : _e.some(
      (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
    )
  );
  const hasSingleSku = (childCatalogData == null ? void 0 : childCatalogData.length) === 1;
  const publishedChildItems = {
    catalogData: childCatalogData == null ? void 0 : childCatalogData.filter(
      (cItem) => Boolean(cItem.isPublished)
    )
  };
  const inWarehouseChannelBadgeData = getInWareHouseChannelBadgeData(
    item,
    enabledWarehousesListConfig,
    cookieContext,
    (featureToggleConfig == null ? void 0 : featureToggleConfig.showMultiVariantsAvailability) || false,
    hasSingleSku,
    inventoryResponseData
  );
  return {
    ...normalizedDataV1,
    availabilityInfoData: {
      ...normalizedDataV1 == null ? void 0 : normalizedDataV1.availabilityInfoData,
      inWarehouseChannelBadgeData
    },
    deliveryChannelData: getDeliveryChannelBadgeData(
      item,
      bopiwWarehouseEnabled,
      wioWarehouseEnabled,
      inventoryResponseData
    ),
    priceListData: getPriceData(
      item,
      hasSingleSku,
      cookieContext,
      !isPublished ? childCatalogData : publishedChildItems,
      ecoFee,
      hasUserSignedId,
      isProductDetailsPage,
      {
        translationsConfig,
        inWarehouseChannelBadgeData,
        locale
      }
    ),
    discountsData: getDiscountsData(item, cookieContext, {
      inWarehouseChannelBadgeData,
      locale,
      hasSingleSku
    }),
    savingsData: {
      salePrice: childCatalogDisplayPrice == null ? void 0 : childCatalogDisplayPrice.deliveredPrice,
      listPrice: childCatalogDisplayPrice == null ? void 0 : childCatalogDisplayPrice.onlinePrice
    },
    productInfoData: {
      ...normalizedDataV1 == null ? void 0 : normalizedDataV1.productInfoData,
      replacementItemNumber: getReplacementItemNumber(
        item,
        cookieContext,
        {
          inWarehouseChannelBadgeData,
          locale,
          hasSingleSku
        }
      )
    }
  };
};
export {
  normalizeProductSummaryApiV2
};
